import Settings from "../../../../modules/Settings/Settings";
import MobileSliderPagesWrapper from "../components/MobileSliderPagesWrapper";
import MobileSliderPagesHeader from "../components/MobileSliderPagesHeader";
import React, { useCallback } from "react";
import { MobileProfileNotificationIconContainerStyled } from "../../styled/MobileProfileStyled";
import { BinIcon } from "../../../../components/icon/Icon";
import { openMobileSliderPageAction } from "../../../mobileAppActions";
import { openNotificationAction } from "../../../../modules/Notifications/notificationsActions";
import { connect } from "react-redux";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import { MobileSliderPagesContentStyled } from "../components/styled/MobileSliderPagesStyled.js";

function SlideMobileSettings(props) {
    const {openNotification} = props;
    const {getLangPath} = useLangContext();

    const successPasswordChangeCallback = useCallback(() => {
        openNotification({
            content: <div className="d-flex flex-column align-items-center">
                <MobileProfileNotificationIconContainerStyled>
                    <BinIcon name="IcCheckMarkCircle" className="icon" style={{fill: 'var(--color-green-secondary)'}}/>
                </MobileProfileNotificationIconContainerStyled>
                <div className="fw600 f20 mt-3">{getLangPath('settings_modal.password_changed')}</div>
            </div>,
            options: {
                closeButton: false,
            }
        });
    }, [getLangPath, openNotification]);

    return <MobileSliderPagesWrapper>
        <div className="h-100 d-flex flex-column">
            <MobileSliderPagesHeader goBack>
                <h4 className="mb-0 text-center">{getLangPath('menu.settings')}</h4>
            </MobileSliderPagesHeader>
            <MobileSliderPagesContentStyled>
                <Settings containersClassname="px-0" onSuccessPasswordChangeCallback={successPasswordChangeCallback}/>
            </MobileSliderPagesContentStyled>
        </div>
    </MobileSliderPagesWrapper>
}

const mapDispatchToProps = (dispatch) => ({
    openMobileSliderPage: (payload) => dispatch(openMobileSliderPageAction(payload)),
    openNotification: (payload) => dispatch(openNotificationAction(payload)),
});

export default connect(null, mapDispatchToProps)(SlideMobileSettings);
